





















import { Component, Mixins, Watch, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../system/mixins";
import { EditingDocument } from "..";
import PageSilhouetteSelector from "./PageSilhouetteSelector.vue";
import { PageListTool } from "./tools";

@Component({
  components: {
    PageSilhouetteSelector,
    PageListTool,
  }
})
export default class PageNavigator extends Mixins(ModelEditableMixin) {
  readPropertyOrDefault: <T>(reader: (source: EditingDocument) => T, defaultValue: T) => T;

  @Prop()
  isRightSide: boolean;

  data(): any {
    return {
      isExpanded: undefined,  // 初期値はundefined.
    };
  }
  isExpanded: boolean;

  get expanderLayoutStyle(): any {
    return {
      width: this.$configuration.behavior.document.editor.pageNavigator.expander.areaWidth + "px",
      fontSize: this.$configuration.behavior.document.editor.pageNavigator.expander.fontSize + "px",
    };
  }

  get rootLayoutStyle() {
    return {
      flexDirection: this.isRightSide
        ? "row"
        : "row-reverse",
    };
  }

  get isReady(): boolean {
    return (this.isExpanded !== undefined);
  }

  get pageCount(): number {
    return this.readPropertyOrDefault(s => s.sections.length, 0);
  }

  get isVisible(): boolean {
    return this.isReady
        && this.isEnablePageCount(this.$configuration.behavior.document.editor.pageNavigator.visiblePageCount);
  }

  private isEnablePageCount(configuration: number): boolean {
    return (1 <= configuration)
        && (configuration <= this.pageCount);
  }

  get isExpandable(): boolean {
    return this.isVisible
        && this.isEnablePageCount(this.$configuration.behavior.document.editor.pageNavigator.expandablePageCount);
  }

  get expanderText(): string {
    return this.xor(this.isRightSide, this.isExpanded)
      ? "<"
      : ">"; 
  }

  xor(a: boolean, b: boolean): boolean {
    return (a || b) && !(a && b);
  }

  @Watch("pageCount")
  onPageCountChanged(newValue: number, oldValue: number)  {
    if (this.isReady || (newValue < 1)) {
      return;
    }
    this.isExpanded = this.isEnablePageCount(this.$configuration.behavior.document.editor.pageNavigator.visiblePageCount)
                    && this.isEnablePageCount(this.$configuration.behavior.document.editor.pageNavigator.expandablePageCount)
                    && this.isEnablePageCount(this.$configuration.behavior.document.editor.pageNavigator.pageCountToExpand);
  }

  get expandedWidth(): number {
    return this.$configuration.behavior.document.editor.pageNavigator.expandedWidth;
  }

  get expandedWidthStyleProperties(): any {
    return {
      width: this.expandedWidth + "px",
    };
  }

  get indicatorFontSize(): number {
    // もともとは横幅300pxに対して100pxの文字サイズだった
    // だいたい同じ比率で表示するようにしている
    return Math.round(100 * this.expandedWidth / 300);
  }
}
